import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Utilities from '@/Utility/Utilities';

export default class AutoLocatorBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.autoLocator = {
            update: (element, valueAccessor, bindings, view, bindingContext) => {
                let name = ko.unwrap(valueAccessor());

                let locator = '';

                if (name != null && typeof name == 'object') {
                    let parent = Utilities.isFunction(name.parent) ? name.parent() : name.parent;
                    locator = Utilities.isFunction(name.name) ? name.name() : name.name;
                    if (locator != null && locator != '' && parent != null && parent != '') {
                        locator = parent + '.' + locator;
                    }
                } else if (name != null && Utilities.isFunction(name)) {
                    locator = name();
                } else
                    locator = name;

                if (locator == null || locator == '') {
                    return;
                }

                let $element = $(element);

                $element.attr('data-locator', locator);

                $element.find('*').each((i, child) => {
                    $(child).attr('data-locator', locator + '@' + i);
                });
            }
        };
    }
}